/**
 * Add-to-cart celebration: sparkle burst from the clicked button plus a success toast.
 */
(function () {
  var COLORS = ['#b85c42', '#d4a24c', '#f0c987', '#e07a5f', '#f5f0e8'];
  var PARTICLES = 42;
  var DURATION = 1300;
  var GRAVITY = 0.00055;
  var ORIGIN_MAX_AGE = 15000;
  var TOAST_MS = 3200;

  var lastOrigin = null;
  var lastCelebrate = 0;
  var canvas = null;
  var ctx = null;
  var particles = [];
  var running = false;
  var toastTimer = null;

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function addSelector() {
    return (window.KKCart && window.KKCart.addButtonSelector) || '[data-kk-add-to-cart], button[name="add"]';
  }

  function rememberOrigin(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var btn = target.closest(addSelector());
    if (!btn) return;
    var rect = btn.getBoundingClientRect();
    lastOrigin = {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
      time: Date.now(),
    };
  }

  function ensureCanvas() {
    if (canvas) return ctx;
    canvas = document.createElement('canvas');
    canvas.className = 'kk-cart-celebrate__canvas';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);
    ctx = canvas.getContext('2d');
    sizeCanvas();
    window.addEventListener('resize', sizeCanvas);
    return ctx;
  }

  function sizeCanvas() {
    if (!canvas || !ctx) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.floor(window.innerWidth * dpr);
    canvas.height = Math.floor(window.innerHeight * dpr);
    canvas.style.width = window.innerWidth + 'px';
    canvas.style.height = window.innerHeight + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function drawStar(x, y, r, rotation) {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(rotation);
    ctx.beginPath();
    for (var i = 0; i < 8; i += 1) {
      var radius = i % 2 === 0 ? r : r * 0.32;
      var angle = (Math.PI / 4) * i;
      ctx.lineTo(Math.cos(angle) * radius, Math.sin(angle) * radius);
    }
    ctx.closePath();
    ctx.fill();
    ctx.restore();
  }

  function frame(now) {
    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    particles = particles.filter(function (p) {
      var t = now - p.start;
      if (t >= DURATION) return false;
      var progress = t / DURATION;
      var x = p.x + p.vx * t;
      var y = p.y + p.vy * t + 0.5 * GRAVITY * t * t;
      ctx.globalAlpha = Math.max(0, 1 - progress * progress);
      ctx.fillStyle = p.color;
      if (p.star) {
        var twinkle = 0.75 + 0.25 * Math.sin(t / 60 + p.phase);
        drawStar(x, y, p.size * twinkle, p.rotation + t * p.spin);
      } else {
        ctx.beginPath();
        ctx.arc(x, y, p.size * 0.45 * (1 - progress * 0.5), 0, Math.PI * 2);
        ctx.fill();
      }
      return true;
    });
    ctx.globalAlpha = 1;
    if (particles.length) {
      requestAnimationFrame(frame);
    } else {
      running = false;
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    }
  }

  function burst(x, y) {
    if (!ensureCanvas()) return;
    var now = performance.now();
    for (var i = 0; i < PARTICLES; i += 1) {
      var angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.6;
      var speed = 0.18 + Math.random() * 0.32;
      particles.push({
        x: x,
        y: y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        size: 5 + Math.random() * 6,
        color: COLORS[i % COLORS.length],
        star: i % 3 !== 0,
        rotation: Math.random() * Math.PI,
        spin: (Math.random() - 0.5) * 0.01,
        phase: Math.random() * Math.PI * 2,
        start: now + Math.random() * 120,
      });
    }
    if (!running) {
      running = true;
      requestAnimationFrame(frame);
    }
  }

  function addedTitle(cartData) {
    if (!cartData) return '';
    var item = cartData.items && cartData.items[0];
    return (item && item.product_title) || cartData.product_title || '';
  }

  function ensureToast() {
    var toast = document.querySelector('[data-kk-cart-toast]');
    if (toast) return toast;
    toast = document.createElement('div');
    toast.className = 'kk-cart-toast';
    toast.setAttribute('data-kk-cart-toast', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<span class="kk-cart-toast__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>' +
      '</span>' +
      '<span class="kk-cart-toast__body">' +
      '<span class="kk-cart-toast__title">Product added successfully</span>' +
      '<span class="kk-cart-toast__sub" data-kk-cart-toast-sub hidden></span>' +
      '</span>' +
      '<a class="kk-cart-toast__link" data-kk-cart-toast-link href="/cart">View cart</a>';
    document.body.appendChild(toast);
    return toast;
  }

  function showToast(title) {
    var toast = ensureToast();
    var sub = toast.querySelector('[data-kk-cart-toast-sub]');
    if (sub) {
      sub.textContent = title || '';
      sub.hidden = !title;
    }
    var link = toast.querySelector('[data-kk-cart-toast-link]');
    if (link) link.href = (window.routes && window.routes.cart_url) || '/cart';
    toast.classList.remove('is-visible');
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, TOAST_MS);
  }

  function celebrate(cartData) {
    var now = Date.now();
    if (now - lastCelebrate < 600) return;
    lastCelebrate = now;

    if (!reducedMotion() && document.body) {
      var origin = lastOrigin && now - lastOrigin.time < ORIGIN_MAX_AGE ? lastOrigin : null;
      burst(origin ? origin.x : window.innerWidth / 2, origin ? origin.y : window.innerHeight * 0.6);
    }
    lastOrigin = null;
    if (document.body) showToast(addedTitle(cartData));
  }

  function isCartAdd(input, init) {
    var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
    var method = (init && init.method) || (input && input.method) || 'GET';
    return String(method).toUpperCase() === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(String(url).split('#')[0]);
  }

  window.addEventListener('pointerdown', rememberOrigin, true);
  window.addEventListener('click', rememberOrigin, true);

  if (typeof window.fetch === 'function' && !window.fetch.__kkCelebrate) {
    var nativeFetch = window.fetch;
    var wrappedFetch = function (input, init) {
      var request = nativeFetch.apply(this, arguments);
      if (!isCartAdd(input, init)) return request;
      request
        .then(function (response) {
          if (!response || !response.ok) return;
          response
            .clone()
            .json()
            .then(function (data) {
              if (data && data.status) return;
              celebrate(data);
            })
            .catch(function () {
              celebrate(null);
            });
        })
        .catch(function () {});
      return request;
    };
    wrappedFetch.__kkCelebrate = true;
    window.fetch = wrappedFetch;
  }
})();
